import Vue from 'vue'
import vueEventCalendar from 'vue-event-calendar'

Vue.use(vueEventCalendar, {locale: 'pt-br'})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/event-calendar.js